import Config from 'react-native-config';

export const keys = {
  CURRENT_USER: `${Config.KEY_NAME}_CURRENT_USER`,
  FAVORITE: `${Config.KEY_NAME}_FAVORITE`,
  NOTES: `${Config.KEY_NAME}_NOTES`,
  LANG: `${Config.KEY_NAME}_LANGUAGE`,
  DARK_MODE: `${Config.KEY_NAME}_DARK_MODE`,
  FONT: `${Config.KEY_NAME}_FONT`,
  ONBOARDING: `${Config.KEY_NAME}_ONBOARDING`,
  LAST_LOGIN: `${Config.KEY_NAME}_LAST_LOGIN`,
  SORT_TABS: `${Config.KEY_NAME}_SORT_TABS`,
  CHOOSE_SPECIALITY_SEEN: `${Config.KEY_NAME}_CHOOSE_SPECIALITY_SEEN`,
  CHAT_CATEGORIES: `${Config.KEY_NAME}_CHAT_CATEGORIES`,
};
